import React from 'react';

import FloatingPanel from '../../../../../../components/tooltips/FloatingPanel';
import PopupPanelMouseManager from '../../../../../../components/popupPanel/PopupPanelMouseManager';
import TagsMoveButtons from '../TagMoveButtons';
import TagDeleteButton from '../TagDeleteButton';

import { TooltipAlignment, TooltipPositions } from '../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import { TagsToolbarPopupProps } from './TagsToolbarPopup';

const TagEditPopup = (props: TagsToolbarPopupProps) => {
    const { tag, showEditingPopup } = props;
    if (!tag) return null;

    return (
        <FloatingPanel
            className="light"
            selector={`#tag-${tag._id}`}
            pollPosition
            offset={20}
            showArrow={false}
            distance={20}
            alignment={TooltipAlignment.START}
            position={TooltipPositions.RIGHT}
            show={showEditingPopup}
        >
            <PopupPanelMouseManager visible={showEditingPopup} popupId={PopupIds.TAG_EDIT_MENU} closePopup={() => {}}>
                <TagsMoveButtons {...props} />
                <TagDeleteButton {...props} />
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

export default TagEditPopup;
